function enforceDateRangeForFilters() {
  $("input[id^=\"search_processed_transactions_eq\"],\n      input[id^=\"search_front_end_rejects_eq\"],\n      input[id^=\"search_preauthorization_eq\"],\n      input[id^=\"search_captured_eq\"]").on('click', function () {
    if (!$('#by_payment_days').is(':checked')) {
      $('#by_payment_days').trigger('click');
    }
  });
}

export default {
  enforceDateRangeForFilters: enforceDateRangeForFilters
};